<template>
  <section>
    <div class="comDeclareResource">
      <com-tabs
        :list="libraryInfo.obj.tabs3"
        class="comDeclareResource-tabs"
        :default-tab="activeTab"
        @change="changeTab"
      >
        <template v-slot:text="{ obj }">
          <div
            :class="{ activeTab: activeTab == obj.key }"
            class="comDeclareResource-tabs-item"
          >
            {{ obj.name }}
          </div>
        </template>
      </com-tabs>
      <div class="comDeclareResource-content">
        <com-step0
          v-show="activeTab == 0"
          v-model="data1"
          :action="action"
          :state="state"
          @add="handleAddImg"
          @del="handleDelImg"
          @input="init"
        />
        <com-step1
          v-show="activeTab == 1"
          v-model="data2"
          :action="action"
          :state="state"
          @add="handleAddVideo"
          @del="handleDelVideo"
          @input="init"
        />
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api/app'
import mock from '@/utils/mock'
import comTabs from '@/components/comTabs'
import comStep0 from './details/comStep0.vue'
import comStep1 from './details/comStep1.vue'
export default {
  name: 'ComcomDeclareResource',
  components: {
    comTabs,
    comStep0,
    comStep1
  },
  props: {
    state: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      libraryInfo: mock.library.declare.viewInfo,
      libraryInit: mock.library.declare.init,
      data1: [],
      data2: [],
      activeTab: 0,
      requestParams1: {
        type: 'img',
        url: null
      },
      requestParams2: {
        type: 'video',
        url: null
      }
    }
  },
  computed: {
    action() {
      return `${process.env.VUE_APP_BASE_API}api/uploadFile`
    }
  },
  watch: {},
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      if (this.activeTab == 0) {
        this.data1 = await this.libraryInit.data3({ type: 'img' })
      } else {
        this.data2 = await this.libraryInit.data3({ type: 'video' })
      }
    },
    changeTab(x, y) {
      this.activeTab = x
      this.init()
    },
    cancelSubmit() {
      this.$emit('input')
    },
    handleAddImg(v) {
      this.requestParams1.url = v.join(',')
      api.library.create.libraryMedia(this.requestParams1).then((res) => {
        this.data1.forEach(item => {
          if (!item.id) {
            item.id = res.data.id
          }
        })
      }).catch(() => {
        this.$message.error('上传失败')
      })
    },
    handleDelImg(v) {
      api.library.delete.libraryMedia({ id: v.id }).then((res) => {
        // this.init()
      }).catch(() => {
        this.$message.error('操作失败')
      })
    },
    handleAddVideo(v) {
      this.requestParams2.url = v.join(',')
      api.library.create.libraryMedia(this.requestParams2).then((res) => {
        this.init()
      })
    },
    handleDelVideo(v) {
      api.library.delete.libraryMedia({ id: v.id }).then((res) => {
        this.init()
        this.$message.susser('删除成功')
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.comDeclareResource {
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &-tabs {
    margin-bottom: 22px;
    &-item {
      text-align: center;
      font-size: 10px;
      line-height: 32px;
      width: 112px;
      cursor: pointer;
      @include fun-design(4);
      border-radius: 6px;
      margin-right: 30px;
    }
    .activeTab {
      @include fun-active(1);
    }
  }
  &-content {
    flex: 1;
    width: 100%;
    @include fun-layout(2);
    margin-bottom: 10px;
    // min-height: 680px;
    > section {
      height: 100%;
    }
  }
}
</style>
